var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.083,
    height: 20,
    viewBox: "0 0 18.083 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8738",
    "data-name": "Group 8738",
    transform: "translate(-1093 -758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8739",
    "data-name": "Group 8739",
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8737",
    "data-name": "Group 8737",
    transform: "translate(1085 761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8734",
    "data-name": "Group 8734",
    transform: "translate(3.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8736",
    "data-name": "Group 8736"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14443",
    "data-name": "Rectangle 14443",
    width: 12,
    height: 16,
    rx: 2,
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8735",
    "data-name": "Group 8735",
    transform: "translate(1090.083 758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8734-2",
    "data-name": "Group 8734",
    transform: "translate(3.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8736-2",
    "data-name": "Group 8736"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14443-2",
    "data-name": "Rectangle 14443",
    width: 12,
    height: 16,
    rx: 2,
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/Copy icon.0313b357244a87f1229d733810b4aae2.svg";
export { ForwardRef as ReactComponent };